import React from 'react'

export function StepIndicator({ currentStep, totalSteps }: { currentStep: number; totalSteps: number }) {
    const steps = Array.from({ length: totalSteps }, (_, step) => (
        <div className={`size-[5px] rounded-full ${step + 1 === currentStep ? 'w-[18px] bg-blue50' : 'bg-grey80'}`} key={step + 1} />
    ))

    return <div className="py-[14px] px-[18px] rounded-[20px] flex gap-[6px] bg-blue20 w-fit">{steps}</div>
}
